export default __webpack_public_path__ + "static/media/achtung.15c0314c.svg";